import { render, staticRenderFns } from "./trilha-dificuldade.vue?vue&type=template&id=187965d2&scoped=true"
import script from "./trilha-dificuldade.vue?vue&type=script&lang=js"
export * from "./trilha-dificuldade.vue?vue&type=script&lang=js"
import style0 from "./trilha-dificuldade.vue?vue&type=style&index=0&id=187965d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187965d2",
  null
  
)

export default component.exports